import React from 'react';
import './index.less';

export default ({ children, wrapperClassName, top, ...restProps }) => (
    <div className={`page-header-layout ${wrapperClassName}`}>
        {top}
        {children ? <div className={'content'}>{children}</div> : null}
    </div>
);
